import { TextField } from "@material-ui/core";

function ContentEmailSubject({fieldData, disabled, setIsEditedCurrentTicket, currentMailSubject, setCurrentMailSubject}) {

    const handleInputChange = (e) => {
        const value = e.target.value
        setCurrentMailSubject(value)
        setIsEditedCurrentTicket(true)
    }

    const handleInputBlur = (e) => {
        const value = e.target.value
        setCurrentMailSubject(value.trim())
    }

    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{fieldData?.name?.jp?.text}</label></div>
            <TextField
                fullWidth
                variant="outlined"
                className={`form-control-wrapInput form-control-hg40 email-response-address-input`}
                inputProps={{style: {color: '#2E3138' }}}
                value={currentMailSubject}
                disabled={disabled}
                onChange={e => handleInputChange(e)}
                onBlur={e => handleInputBlur(e)}
            />
        </div>
    );
}

export default ContentEmailSubject;
